import { makeApiRequest, proxyUrl } from './_index'

export async function getDriveFiles(body) {
  const url = `${proxyUrl}/api/google-apis/list-files`
  const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
  }

  return makeApiRequest(url, options)
}